module.exports = __webpack_public_path__ + "static/testi-1-1-7747932ff5cdfb7f096c35cbb859d65e.jpg";